export const ADD_STRIPE_PUBLIC_KEY = 'addStripePublicKey';
